export default __webpack_public_path__ + "static/media/mobile-title.9fae7d95.svg";